module.exports = {"510682001":"方亭街道","510682002":"皂角街道","510682101":"元石镇","510682103":"回澜镇","510682105":"洛水镇","510682106":"禾丰镇","510682107":"双盛镇","510682108":"马祖镇","510682109":"隐峰镇","510682110":"马井镇","510682111":"蓥华镇","510682113":"南泉镇","510682116":"湔氐镇","510682118":"红白镇","510682119":"冰川镇","510682120":"师古镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510682.json
// module id = 2298
// module chunks = 0